import styled from "styled-components";

import { BaseCell } from "@similarweb/pro-logic-components";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
`;
